"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        skuId: '',
        spuCode: '',
        skuCode: '',
        spuName: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      detailList: [],
      addProductOptions: [],
      batchProductOptions: [],
      addDialogVisible: false,
      addSubmitting: false,
      addForm: {
        skuId: '',
        cardType: 0,
        validityRange: [],
        remark: ''
      },
      addRules: {
        skuId: [{
          required: true,
          message: '请选择商品',
          trigger: 'change'
        }],
        cardType: [{
          required: true,
          message: '请选择卡密类型',
          trigger: 'change'
        }],
        validityRange: [{
          validator: function validator(rule, value, callback) {
            if (_this.addForm.cardType === 1 && value && value.length !== 0 && value.length !== 2) {
              callback(new Error('使用有效期开始和结束日期需同时选择'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }]
      },
      batchDialogVisible: false,
      batchSubmitting: false,
      batchForm: {
        channelType: 1,
        skuId: '',
        generateCount: 1,
        expiryType: 0,
        validDays: 0
      },
      batchRules: {
        channelType: [{
          required: true,
          message: '请选择生成卡密类型',
          trigger: 'change'
        }],
        skuId: [{
          required: true,
          message: '请选择关联商品',
          trigger: 'change'
        }],
        generateCount: [{
          required: true,
          message: '请输入生成数量',
          trigger: 'blur'
        }],
        expiryType: [{
          required: true,
          message: '请选择有效期',
          trigger: 'change'
        }],
        validDays: [{
          required: true,
          message: '请输入激活后天数',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    this.loadAddProductOptions();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    resetSearch: function resetSearch() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        skuId: '',
        spuCode: '',
        skuCode: '',
        spuName: ''
      };
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      storeApi.cardSkuLists(pram).then(function (data) {
        _this2.listData = data || {
          list: [],
          total: 0
        };
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listData = {
          list: [],
          total: 0
        };
        _this2.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handleAddCard: function handleAddCard() {
      this.addDialogVisible = true;
      this.loadAddProductOptions();
    },
    handleBatchCard: function handleBatchCard() {
      this.batchDialogVisible = true;
      this.loadBatchProductOptions();
    },
    handleOperationLog: function handleOperationLog() {
      this.$router.push({
        name: 'cardInventoryOperationLog'
      });
    },
    loadAddProductOptions: function loadAddProductOptions() {
      var _this3 = this;
      if (!storeApi.cardSkuProductOptions) return;
      storeApi.cardSkuProductOptions().then(function (res) {
        var raw = res || [];
        _this3.addProductOptions = raw.map(function (it) {
          return {
            label: it.value || '',
            value: it.key,
            type: it.type
          };
        });
      }).catch(function () {
        _this3.addProductOptions = [];
      });
    },
    loadBatchProductOptions: function loadBatchProductOptions() {
      var _this4 = this;
      if (!storeApi.cardBatchSkuOptions) return;
      storeApi.cardBatchSkuOptions().then(function (res) {
        var raw = res || [];
        _this4.batchProductOptions = raw.map(function (it) {
          return {
            label: it.value || '',
            value: it.key,
            type: it.type
          };
        });
      }).catch(function () {
        _this4.batchProductOptions = [];
      });
    },
    onExpiryTypeChange: function onExpiryTypeChange(val) {
      if (val === 0) {
        this.batchForm.validDays = 0;
      }
      this.$refs.batchFormRef && this.$refs.batchFormRef.validateField('validDays');
    },
    onCardTypeChange: function onCardTypeChange() {
      if (this.addForm.cardType === 0) this.addForm.validityRange = [];
      this.$refs.addFormRef && this.$refs.addFormRef.validateField('validityRange');
    },
    submitAdd: function submitAdd() {
      var _this5 = this;
      this.$refs.addFormRef.validate(function (valid) {
        if (!valid) return;
        var payload = {
          skuId: _this5.addForm.skuId,
          cardType: _this5.addForm.cardType,
          validStartTime: _this5.addForm.cardType === 1 && _this5.addForm.validityRange.length === 2 ? _this5.addForm.validityRange[0] : undefined,
          validEndTime: _this5.addForm.cardType === 1 && _this5.addForm.validityRange.length === 2 ? _this5.addForm.validityRange[1] : undefined,
          remark: _this5.addForm.remark
        };
        _this5.addSubmitting = true;
        var api = storeApi.cardSkuAdd;
        if (api) {
          api(payload).then(function () {
            _this5.$message.success('添加成功');
            _this5.addDialogVisible = false;
            _this5.handlerGetListData(_this5.listPram);
          }).catch(function (err) {
            _this5.$message.error(err && err.msg || '添加失败');
          }).finally(function () {
            _this5.addSubmitting = false;
          });
        } else {
          _this5.$message.warning('添加卡密接口待对接');
          _this5.addSubmitting = false;
        }
      });
    },
    resetAddForm: function resetAddForm() {
      var _this6 = this;
      this.$nextTick(function () {
        if (_this6.$refs.addFormRef) _this6.$refs.addFormRef.clearValidate();
      });
      this.addForm = {
        skuId: '',
        cardType: 0,
        validityRange: [],
        remark: ''
      };
    },
    submitBatch: function submitBatch() {
      var _this7 = this;
      this.$refs.batchFormRef.validate(function (valid) {
        if (!valid) return;
        var payload = {
          channelType: _this7.batchForm.channelType,
          skuId: _this7.batchForm.skuId,
          generateCount: _this7.batchForm.generateCount,
          validDays: _this7.batchForm.expiryType === 1 ? _this7.batchForm.validDays : 0
        };
        _this7.batchSubmitting = true;
        var api = storeApi.cardBatchGenerate;
        if (api) {
          api(payload).then(function () {
            _this7.$message.success('生成成功');
            _this7.batchDialogVisible = false;
            _this7.handlerGetListData(_this7.listPram);
          }).catch(function (err) {
            _this7.$message.error(err && err.msg || '生成失败');
          }).finally(function () {
            _this7.batchSubmitting = false;
          });
        } else {
          _this7.$message.warning('生成批次卡密接口待对接');
          _this7.batchSubmitting = false;
        }
      });
    },
    resetBatchForm: function resetBatchForm() {
      var _this8 = this;
      this.$nextTick(function () {
        if (_this8.$refs.batchFormRef) _this8.$refs.batchFormRef.clearValidate();
      });
      this.batchForm = {
        channelType: 1,
        skuId: '',
        generateCount: 1,
        expiryType: 0,
        validDays: 0
      };
    },
    handleStockDetail: function handleStockDetail(row) {
      this.$router.push({
        name: 'cardInventoryDetail',
        params: {
          skuId: row.skuId
        },
        query: {
          productName: row.productName || '',
          cardType: row.cardType == null ? 0 : row.cardType
        }
      });
    },
    statusText: function statusText(val) {
      var map = {
        0: '未使用',
        1: '已使用',
        2: '已冻结',
        3: '已作废'
      };
      return map[val] != null ? map[val] : '-';
    },
    statusTagType: function statusTagType(val) {
      var map = {
        0: 'success',
        1: 'info',
        2: 'warning',
        3: 'danger'
      };
      return map[val] != null ? map[val] : 'info';
    }
  }
};